// extracted by mini-css-extract-plugin
export var container = "_u1-0";
export var table = "_u1-2";
export var tableWrapper = "_u1-1";